module.exports = __webpack_public_path__ + "static/media/deptimage2.9f3e7032.jpg";